import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { PatientDocument } from '../models/patient-document.model';

export interface IPatientDocumentsRepository {
  list(organizationId: number, patientId: string): Observable<readonly PatientDocument[]>;
  upload(organizationId: number, patientId: string, file: File): Observable<PatientDocument>;
  download(organizationId: number, documentId: number): Observable<Blob>;
  remove(organizationId: number, documentId: number): Observable<void>;
}

export const PATIENT_DOCUMENTS_REPOSITORY =
  new InjectionToken<IPatientDocumentsRepository>('IPatientDocumentsRepository');
